import React from 'react'

// Antd
import { Avatar, Layout, theme, Tooltip, Space, Button } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
} from '@ant-design/icons';

// Router
import { Link, useHistory } from 'react-router-dom';

import './style.scss'
import { useDispatch, useSelector } from 'react-redux';
import { setUserProfile } from '../../../../Reducers/userProfileReducer';

import { DEFAULT_USER_PROFILE_IMAGE } from '../../../../Constants/Api/azure/azure';

const { Header } = Layout;

const items = [
    {
        label:
            <Link to='/dashboard/profile'>
                <Button
                    type='link'
                >
                    <UserOutlined /> View Profile
                </Button>
            </Link>,
        key: '0',
    },
    {
        label: <Button
            type='link'
        >
            <LogoutOutlined /> Sign Out
        </Button>,
        key: '1',
    },
];

const DashboardHeader = ({ collapsed, setCollapsed }) => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const userProfile = useSelector((state) => state.userProfile?.userProfile)
    const dispatch = useDispatch();
    const navigate = useHistory();

    const handleSignOut = async () => {
        localStorage.removeItem('digital-academy-user')
        dispatch(setUserProfile(null))
        window.location.href = '/login';
    }

    const getIndexNumber = (name, index, studentNumber) => {
        if (studentNumber) {
            return studentNumber;
        }
        const firstLetter = name?.charAt(0).toUpperCase();
        if (firstLetter && index) {
            return `${firstLetter}${index}`
        } else {
            return 'Please wait...'
        }
    }

    return (
        <Header
            className='dashboard-header'
            style={{
                padding: 0,
                background: colorBgContainer,
            }}
        >
            <div className='header-left-wrap'>
                {setCollapsed && (
                    <Button
                        type='text'
                        className='mobile-sidebar-toggle'
                        icon={collapsed ? <MenuUnfoldOutlined style={{ fontSize: 20 }} /> : <MenuFoldOutlined style={{ fontSize: 20 }} />}
                        onClick={() => setCollapsed(!collapsed)}
                    />
                )}
                <img
                    src={require('../../../../Assets/Logos/ibas_logo.jpeg')}
                    alt="logo"
                    className='mobile-header-logo'
                />
            </div>
            <Tooltip
                overlayClassName='user-profile-tooltip'
                color='white'
                placement="bottom"
                trigger={['click']}
                title={
                    <Space direction="vertical">
                        {
                            items.map((item) => {
                                return (
                                    <div
                                        key={item.key}
                                        onClick={() => {
                                            if (item.key === '1') {
                                                handleSignOut()
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </div>
                                );
                            })
                        }
                    </Space>
                }
            >
                <div className='profile-bar'>
                    <Avatar
                        size="large"
                        src={userProfile?.profileImage ? userProfile?.profileImage : DEFAULT_USER_PROFILE_IMAGE}
                    />
                    <div className='profile-name'>
                        <p>
                            {userProfile?.name || 'User'}
                        </p>
                        <h5>
                            {(userProfile?.studentNumber || userProfile?.indexNumber) ? getIndexNumber(userProfile?.name, userProfile?.indexNumber, userProfile?.studentNumber) : 'Index Number'}
                        </h5>
                    </div>
                </div>
            </Tooltip>
        </Header>
    )
}

export default DashboardHeader